import React, { useState, useEffect } from 'react';
import { Col, Row, Breadcrumb, Table, Spin, message } from 'antd';
import { SupplyChainTrackingCols } from '../data/Columns';
import AssetTrackingForm from '../components/reports/AssetTrackingForm';
import { fetchAssetsData } from '../data/BlockchainApi';

const CONSORTIUM_OPTIONS = [
    { value: 102, label: 'Greece Pilot' },
    { value: 103, label: 'Serbia Pilot' },
];


function SupplyChainTracking() {
    const [assets, setAssets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        consortiumId: 102,
        gtin: '',
        producerGLN: '',
        lotNumber: '',
        fromDate: '',
        toDate: ''
    });
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });


    // Extract everything BEFORE useEffect (IMPORTANT)
    const {
        consortiumId,
        gtin,
        producerGLN,
        lotNumber,
        fromDate,
        toDate
    } = filters;

    const { current, pageSize } = pagination;


    useEffect(() => {
        const skip = (current - 1) * pageSize;

        const apiFilters = {
            gtin,
            producerGLN,
            lotNumber,
            fromDate,
            toDate,
            skip: String(skip),
            limit: String(pageSize)
        };

        const loadAssets = async () => {
            setLoading(true);
            try {
                const response = await fetchAssetsData(consortiumId, apiFilters);

                if (!response) throw new Error("Empty response");

                setAssets(response.assetList || []);

                const recordCount = response.assetRecordCount?.find(
                    item => item._id === consortiumId.toString()
                );

                setPagination(prev => ({
                    ...prev,
                    total: recordCount?.count || 0
                }));

            } catch (err) {
                message.error("Failed to load assets");
                setAssets([]);
            } finally {
                setLoading(false);
            }
        };

        loadAssets();
    }, [
        consortiumId,
        gtin,
        producerGLN,
        lotNumber,
        fromDate,
        toDate,
        current,
        pageSize
    ]);


    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        setPagination(prev => ({ ...prev, current: 1 }));
    };


    const handleTableChange = (newPagination) => {
        setPagination(newPagination);
    };


    return (
        <>
            <div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '50px' }}>
                <h1 style={{ color: '#102F10' }}>
                    <Breadcrumb
                        items={[
                            { title: <a href="/">Home</a> },
                            { title: 'Supply Chain Tracking' }
                        ]}
                    />
                </h1>
            </div>

            <Row gutter={[32, 24]}>
                <Col xs={24}>
                    <AssetTrackingForm
                        filters={filters}
                        onFilterChange={handleFilterChange}
                        onRefresh={() => setPagination({ ...pagination })}
                        consortiumOptions={CONSORTIUM_OPTIONS}
                    />
                </Col>

                <Col xs={24}>
                    <Spin spinning={loading} size="large">
                        <Table
                            columns={SupplyChainTrackingCols}
                            dataSource={assets}
                            rowKey="_id"
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                                showSizeChanger: true,
                                showQuickJumper: true,
                                showTotal: (total, range) =>
                                    `${range[0]}-${range[1]} of ${total} items`,
                                pageSizeOptions: ['10', '20', '50', '100'],
                            }}
                            onChange={handleTableChange}
                            size="middle"
                            scroll={{ x: 800 }}
                        />
                    </Spin>
                </Col>
            </Row>
        </>
    );
}

export default SupplyChainTracking;
